/*
 * FIBRA6 — Kaufleiste (Bewegung Klasse C: Antwort auf den Scrollstand)
 *
 * Zwei Beobachter, kein Scroll-Listener:
 *  1. Sichtbar, solange KEIN Element mit [data-kaufleiste-aus] im Bild ist
 *     (erster Bildschirm, Ausführung, Türen, Fuß zeigen die Aktion selbst).
 *  2. Dunkel, solange eine dunkle Bühne hinter der Leiste liegt — gemessen im
 *     untersten Streifen des Bildschirms, denn nur dort liegt die Leiste.
 *
 * Unsichtbar ist die Leiste zusätzlich inert: nicht fokussierbar, nicht vorlesbar.
 */
(() => {
  const leiste = document.querySelector("[data-kaufleiste]");
  if (!leiste) return;

  if (!("IntersectionObserver" in window)) {
    leiste.classList.add("ist-sichtbar");
    return;
  }

  const imBild = new Set();
  const buehnen = new Set();

  const setze = () => {
    const sichtbar = imBild.size === 0;
    leiste.classList.toggle("ist-sichtbar", sichtbar);
    leiste.inert = !sichtbar;

    const dunkel = buehnen.size > 0;
    leiste.classList.toggle("welt-buehne", dunkel);
    leiste.classList.toggle("welt-hell", !dunkel);
  };

  const merke = (menge) => (eintraege) => {
    for (const e of eintraege) {
      if (e.isIntersecting) menge.add(e.target);
      else menge.delete(e.target);
    }
    setze();
  };

  const ausBeobachter = new IntersectionObserver(merke(imBild));
  const buehnenBeobachter = new IntersectionObserver(merke(buehnen), {
    rootMargin: "-92% 0px 0px 0px",
  });

  const erfasse = (wurzel) => {
    for (const el of wurzel.querySelectorAll("[data-kaufleiste-aus]")) ausBeobachter.observe(el);
    for (const el of wurzel.querySelectorAll(".welt-buehne:not([data-kaufleiste])")) buehnenBeobachter.observe(el);
  };

  const vergiss = (wurzel) => {
    for (const menge of [imBild, buehnen]) {
      for (const el of menge) if (wurzel.contains(el)) menge.delete(el);
    }
    setze();
  };

  erfasse(document);

  // Theme-Editor lädt Sections einzeln neu.
  document.addEventListener("shopify:section:load", (e) => erfasse(e.target));
  document.addEventListener("shopify:section:unload", (e) => vergiss(e.target));
})();
